import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import { hospitalInfo } from "../content/hospitalContent";
import logo from "../assets/logo.png";
import { MdOutlineArrowOutward } from "react-icons/md";

export default function TopBar() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  const navItems = [
    { label: "Home", key: "home" },
    { label: "Services", key: "services" },
    { label: "About Us", key: "about_us" },
    { label: "Careers", key: "careers" },
    { label: "Contact Us", key: "contact_us" },
  ];

  return (
    <div className="TopBar topbar-modern">
      <div className="body topbar-modern-body">
        <div className="container d-flex align-items-center justify-content-between h-100">
          <button type="button" className="hospital-topbar__brand" onClick={() => goTo("home")}>
            <span className="">
              <img src={logo} width={75} alt={`${hospitalInfo.shortName} logo`} />
            </span>
            
          </button>

          <div className="topbar-modern-nav-wrap mDesktopOnly">
            <div className="">
              {navItems.map((item) => (
                <button
                  key={item.key}
                  className={`topbar-modern-link ${appContext.navItem === item.key ? "active" : ""}`}
                  onClick={() => goTo(item.key)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div className="topbar-mobile-actions d-flex d-md-none align-items-center">
            <button
              className="topbar-modern-menu-btn mMobileOnly"
              onClick={appContext.openSideBar}
              aria-label="Open menu"
            >
              <MdMenu size={30} />
            </button>
          </div>

          <div className="d-none d-md-flex align-items-center">
            <a
              href={hospitalInfo.scheduleUrl}
              target="_blank"
              rel="noreferrer"
              className="hospital-topbar__cta hospital-topbar__cta--mobile font-semi-bold me-2"
              aria-label="Schedule appointment"
            >
              Schedule An Appointment &nbsp; <MdOutlineArrowOutward size={20} />
            </a>
          </div>

        </div>
      </div>
    </div>
  );
}
